if (!customElements.get('koko-styled-look')) {
  customElements.define('koko-styled-look', class extends HTMLElement {
    connectedCallback() {
      this.pages = [...this.querySelectorAll('[data-look-page]')];
      this.current = 0;
      this.product = this.closest('.product.has-complete-look');
      this.leftColumn = this.closest('.product__left-column');
      this.info = this.product?.querySelector('.product__info-container');
      this.desktopMedia = window.matchMedia?.('(min-width: 750px)') || { matches: false, addEventListener() {}, removeEventListener() {} };
      this.syncColumnHeight = this.syncColumnHeight.bind(this);
      this.querySelector('[data-look-prev]')?.addEventListener('click', () => this.show(this.current - 1));
      this.querySelector('[data-look-next]')?.addEventListener('click', () => this.show(this.current + 1));
      this.resizeObserver = window.ResizeObserver ? new window.ResizeObserver(this.syncColumnHeight) : null;
      if (this.leftColumn) this.resizeObserver?.observe(this.leftColumn);
      if (this.info) {
        [...this.info.children].filter(child => !child.matches('.koko-pdp-accordions')).forEach(child => this.resizeObserver?.observe(child));
        this.info.querySelectorAll('.koko-pdp-accordion > summary').forEach(summary => this.resizeObserver?.observe(summary));
      }
      this.desktopMedia.addEventListener?.('change', this.syncColumnHeight);
      this.show(0);
      this.syncColumnHeight();
    }
    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.desktopMedia?.removeEventListener('change', this.syncColumnHeight);
    }
    syncColumnHeight() {
      if (!this.product || !this.leftColumn) return;
      if (!this.desktopMedia.matches) {
        this.product.style.removeProperty('--koko-styled-look-column-height');
        return;
      }
      let minimumHeight = 0;
      if (this.info) {
        const outerHeight = element => {
          const style = getComputedStyle(element);
          if (style.display === 'none' || style.position === 'absolute' || style.position === 'fixed') return 0;
          return element.getBoundingClientRect().height + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
        };
        const style = getComputedStyle(this.info);
        minimumHeight = (parseFloat(style.paddingTop) || 0) + (parseFloat(style.paddingBottom) || 0);
        for (const child of this.info.children) {
          if (child.matches('.koko-pdp-accordions')) {
            const accordionStyle = getComputedStyle(child);
            minimumHeight += (parseFloat(accordionStyle.marginTop) || 0) + (parseFloat(accordionStyle.marginBottom) || 0);
            child.querySelectorAll('.koko-pdp-accordion > summary').forEach(summary => { minimumHeight += outerHeight(summary) + 2; });
            minimumHeight += 100;
          } else {
            minimumHeight += outerHeight(child);
          }
        }
      }
      const height = Math.ceil(Math.max(this.leftColumn.getBoundingClientRect().height, minimumHeight));
      if (height > 0) this.product.style.setProperty('--koko-styled-look-column-height', `${height}px`);
    }
    show(index) {
      if (!this.pages.length) return;
      this.current = (index + this.pages.length) % this.pages.length;
      this.pages.forEach((page, pageIndex) => {
        page.hidden = pageIndex !== this.current;
        page.setAttribute('aria-hidden', pageIndex === this.current ? 'false' : 'true');
      });
      const current = this.querySelector('[data-look-current]');
      if (current) current.textContent = String(this.current + 1);
      this.querySelectorAll('[data-look-dot]').forEach((dot, dotIndex) => dot.classList.toggle('is-active', dotIndex === this.current));
      (window.requestAnimationFrame || window.setTimeout)(this.syncColumnHeight);
    }
  });
}
